import PadraoModel from 'src/core/model/PadraoModel.js'

export default class MobiautoCambioModel extends PadraoModel {
  recurso = 'mobiauto/cambios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Câmbios Mobiauto';

  colunasGrid = [
  ];

  form = {
    id: null,
    name: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
